module.exports = __webpack_public_path__ + "img/wallet_02_slick_1.b28a87c9.png";